import IconDropdown from "../Button/IconDropdown";
import React, {useEffect, useState} from "react";
import {Archive, Eye, EyeSlash, InfoCircle, Users} from "flowbite-react-icons/outline";
import {BROKER, VENDOR} from "../../services/constants/CompanyType";
import {patchConversationArchive, patchConversationRead, patchConversationUnread} from "../../services/api/messaging";
import {CONVERSATION_RELOAD, UNREAD_CHECK_EVENT} from "../../services/events";
import ModalReportConversation from "../Modal/ModalReportConversation";
import Modal from "react-modal";
import Notification from "../Common/Notification";
import ModalConversationUsers from "../Modal/ModalConversationUsers";

const MessageActionDropdown = ({
                                   setOpenParticipantsModal = null,
                                   openParticipantsModal = false,
                                   position,
                                   conversationParticipants,
                                   activeConversation,
                                   authData,
                                   onHandleConversationArchived = null,
                                   setSendingMessage = null,
                                   setMessageContent = null,
                                   onHandleConversationSyncUsers = null,
                               }) => {
    const [reportConversationOpen, setReportConversationOpen] = useState(false);
    const handleToggleReportConversation = () => {
        setReportConversationOpen(!reportConversationOpen);
    };
    const [notificationMessage, setNotificationMessage] = useState('');
    const [notificationType, setNotificationType] = useState('');
    const [conversationUsersOpen, setConversationUsersOpen] = useState(openParticipantsModal);


    const handleToggleConversationUsers = () => {
        setConversationUsersOpen(!conversationUsersOpen);
    };
    const handleConversationSyncUsers = (authUserRemoved = false) => {
        onHandleConversationSyncUsers?.(authUserRemoved);
        if (authUserRemoved && !conversationUsersOpen) {
            setConversationUsersOpen(!conversationUsersOpen);
        }
    };

    const handleReportSend = (success) => {
        if (success) {
            setNotificationMessage("Your report has been sent.");
            setNotificationType('success');
        } else {
            setNotificationMessage("Fail to report conversation.");
            setNotificationType('error');
        }
    };

    const clearNotification = () => {
        setNotificationMessage('');
        setNotificationType('');
    };


    const conversationActions = [
        {
            'text': "Report",
            'key': "report",
            icon: <InfoCircle className={"sl-m-auto sl-ml-0 sl-mr-0"} color={"#667085"} size={20}/>
        }];
    if (authData.type === BROKER && !activeConversation.archived) {
        conversationActions.push({
            'text': "Archive",
            'key': "archive",
            icon: <Archive className={"sl-m-auto sl-ml-0 sl-mr-0"} color={"#667085"} size={20}/>
        });
    }

    if (activeConversation.unread) {
        conversationActions.unshift({
            'text': "Mark as read",
            'key': "mark_as_read",
            icon: <Eye color={"#667085"} className={"sl-m-auto sl-ml-0 sl-mr-0"} size={20}/>
        });
    } else {
        conversationActions.unshift({
            'text': "Mark as unread",
            'key': "mark_as_unread",
            icon: <EyeSlash color={"#667085"} className={"sl-m-auto sl-ml-0 sl-mr-0"} size={20}/>
        });
    }

    if (authData.type === VENDOR) {
        conversationActions.unshift({
            'text': "Add/Remove people",
            'key': "add_remove_people",
            icon: <Users className={"sl-m-auto sl-ml-0 sl-mr-0"} color={"#667085"} size={20}/>
        });
    }

    useEffect(() => {
        setConversationUsersOpen(openParticipantsModal)
    }, [openParticipantsModal]);

    useEffect(() => {
            if (!conversationUsersOpen)
                setOpenParticipantsModal?.(false)
        },
        /* eslint-disable react-hooks/exhaustive-deps */
        [conversationUsersOpen])

    const handleConversationStatusChange = async (item) => {
        if (item.key === 'archive') {
            try {
                await patchConversationArchive(activeConversation.id).then((res) => {
                    if (res.message === "Successful") {
                        onHandleConversationArchived?.(activeConversation);
                        setNotificationType('success');
                        setNotificationMessage("Conversation archived.");
                    }
                });
                setSendingMessage?.(false);
                setMessageContent?.('');
            } catch (error) {
                setSendingMessage?.(false);
                console.error('Error fetching messages:', error);
                setNotificationType('error');
                setNotificationMessage("Fail to archive conversation.");
            }
        }
        if (item.key === 'report') {
            handleToggleReportConversation();
        }
        if (item.key === 'mark_as_read') {
            try {
                await patchConversationRead(activeConversation.id);
                const reloadEvent = new Event(CONVERSATION_RELOAD);
                document.dispatchEvent(reloadEvent);

                const readEvent = new Event(UNREAD_CHECK_EVENT);
                document.dispatchEvent(readEvent);

            } catch (error) {
                console.error('Error fetching messages:', error);
            }

        }

        if (item.key === 'mark_as_unread') {
            try {
                await patchConversationUnread(activeConversation.id);

                const reloadEvent = new Event(CONVERSATION_RELOAD);
                document.dispatchEvent(reloadEvent);

                const readEvent = new Event(UNREAD_CHECK_EVENT);
                document.dispatchEvent(readEvent);

            } catch (error) {
                console.error('Error fetching messages:', error);
            }
        }

        if (item.key === 'add_remove_people') {
            setConversationUsersOpen(!conversationUsersOpen);
        }

    };

    return <div>

        <Modal
            isOpen={conversationUsersOpen}
            onRequestClose={() => handleToggleConversationUsers()}
            className="sl-modal-content sl-max-h-185"
            overlayClassName="sl-modal sl-block sl-rounded-md sl-bg-gray-900-opacity-50">
            <ModalConversationUsers participants={conversationParticipants}
                                    authData={authData}
                                    conversation={activeConversation}
                                    onConversationSyncUsers={handleConversationSyncUsers}
                                    onHandleToggle={handleToggleConversationUsers}/>
        </Modal>

        <Modal
            isOpen={reportConversationOpen}
            onRequestClose={() => handleToggleReportConversation()}
            className="sl-modal-content sl-max-h-185"
            overlayClassName="sl-modal sl-block sl-rounded-md sl-bg-gray-900-opacity-50">
            <ModalReportConversation activeConversation={activeConversation}
                                     onReportSend={handleReportSend}
                                     onHandleToggle={handleToggleReportConversation}/>
        </Modal>


        <IconDropdown position={position} iconSize={20} onSelect={handleConversationStatusChange}
                      items={conversationActions}/>

        {notificationMessage.length > 0 &&
            <Notification message={notificationMessage} type={notificationType} onClose={clearNotification}/>}
    </div>
}

export default MessageActionDropdown;